import { forwardRef, useState, useEffect, createElement, memo } from 'react';
import cn from 'classnames';
import { IconButton } from '../IconButton/IconButton.js';
import ReactDayPicker from 'react-day-picker';
import { useLocalization } from '../Provider/Provider.js';

const thisYear = /*#__PURE__*/new Date().getFullYear();
const years = [];

for (let i = thisYear - 10; i <= thisYear + 10; i += 1) {
  years.push(i);
}

const Navbar = /*#__PURE__*/memo(({
  onMonthChange,
  onNextClick,
  onPreviousClick,
  value = new Date()
}) => {
  const {
    texts: {
      calendar: {
        actions,
        months
      }
    }
  } = useLocalization();

  const handleChange = function handleChange(event) {
    const {
      year,
      month
    } = event.target.form;
    onMonthChange(new Date(year.value, month.value));
  };

  return createElement("div", {
    className: "mb-2 flex items-center justify-between"
  }, createElement("form", {
    className: "inline-flex space-x-1"
  }, createElement("select", {
    className: "h-8 px-2",
    name: "month",
    onChange: handleChange,
    value: value.getMonth()
  }, months.map((month, i) => createElement("option", {
    key: month,
    value: i
  }, month))), createElement("select", {
    className: "h-8 px-2",
    name: "year",
    onChange: handleChange,
    value: value.getFullYear()
  }, years.map(year => createElement("option", {
    key: year,
    value: year
  }, String(year))))), createElement("div", null, createElement(IconButton, {
    appearance: "discrete",
    icon: "chevron-left",
    "aria-label": actions.previousMonth,
    onClick: () => onPreviousClick(),
    rounded: true
  }), createElement(IconButton, {
    appearance: "discrete",
    icon: "chevron-right",
    "aria-label": actions.nextMonth,
    onClick: () => onNextClick(),
    rounded: true
  })));
});
const Calendar = /*#__PURE__*/forwardRef(function Calendar(props, ref) {
  const {
    onChange: handleChange,
    value,
    disabledDays,
    ...otherProps
  } = props;
  const {
    locale,
    texts
  } = useLocalization();
  const [visibleMonth, setVisibleMonth] = useState(value !== null && value !== void 0 ? value : new Date());
  useEffect(() => {
    if (visibleMonth !== value) {
      setVisibleMonth(value !== null && value !== void 0 ? value : new Date());
    }
  }, [value]);

  const handleDayClick = (date, modifiers, event) => {
    if (modifiers.outside || modifiers.disabled) {
      return;
    }

    handleChange(date, event);
  };

  const handleCalendarClickToday = () => {
    const today = new Date(); // set to midday to avoid UTC offset causing dates to be mismatched server side

    today.setHours(12);
    today.setMinutes(0);
    today.setSeconds(0);
    handleChange(today);
  };

  const className = cn('flex bg-white text-xs p-4', otherProps.className);
  return createElement("div", {
    "data-taco": "calendar"
  }, createElement(ReactDayPicker, Object.assign({}, otherProps, {
    className: className,
    month: visibleMonth,
    selectedDays: value,
    locale: locale.substring(0, 2),
    firstDayOfWeek: 1,
    months: texts.calendar.months,
    weekdaysShort: texts.calendar.weekdaysShort,
    navbarElement: navProps => createElement(Navbar, Object.assign({}, navProps, {
      onMonthChange: setVisibleMonth,
      value: visibleMonth
    })),
    onDayClick: handleDayClick,
    onMonthChange: setVisibleMonth,
    onTodayButtonClick: handleCalendarClickToday,
    captionElement: () => null,
    todayButton: texts.calendar.actions.today,
    numberOfMonths: 1,
    ref: ref,
    disabledDays: disabledDays
  })));
});

export { Calendar };
//# sourceMappingURL=Calendar.js.map
